import { useDataTable } from "@/lib/hooks/use-data-table.ts";
import { DataTable } from "@/components/data-table/data-table.tsx";
import { getColumns } from "@/components/users/user-details/mentorships/columns.tsx";
import { Mentorship } from "@/lib/api/mentorships.ts";

interface MentorshipsProps {
  userId: string;
  isMentor: boolean;

  mentorships: Mentorship[];
  isPending: boolean;
}

export const Mentorships = ({
  userId,
  isMentor,
  isPending,
  mentorships,
}: MentorshipsProps) => {
  const { table } = useDataTable({
    columns: getColumns(userId, isMentor, mentorships),
    data: mentorships || [],
    defaultPerPage: 10,
    pageCount: -1,
    filterFields: [],
    disablePagination: true,
  });

  return (
    <div>
      <DataTable table={table} isPending={isPending} disablePagination />
    </div>
  );
};
